<template>

    <div>
        <div class="box box-solid">
            <div class="box-header">
                <h2 class="box-title">Facturen (niet project gerelateerd)</h2>
                <div class="box-tools">
                    <div class="btn-group btn-group-xs" v-if="Object.keys(getSpanningYears).length > 1">
                        <button
                            class="btn btn-default btn-xs"
                            v-for="(colspan, year) in getSpanningYears"
                            v-text="year"
                            @click="setYearView(year)"
                        ></button>
                    </div>
                    <div class="btn-group btn-group-xs">
                        <button class="btn btn-default" @click="moveBackwardsYear()" data-tooltip="tooltip" title="Een jaar terug"><i class="fa fa-angle-double-left"></i></button>
                        <button class="btn btn-default" @click="moveBackwards()" data-tooltip="tooltip" title="Een maand terug"><i class="fa fa-angle-left"></i></button>
                        <button class="btn btn-default" @click="moveReset()" v-show="isResetable" data-tooltip="tooltip" title="Terugzetten">Reset</button>
                        <button class="btn btn-default" @click="moveForward()" data-tooltip="tooltip" title="Een maand vooruit"><i class="fa fa-angle-right"></i></button>
                        <button class="btn btn-default" @click="moveForwardYear()" data-tooltip="tooltip" title="Een jaar vooruit"><i class="fa fa-angle-double-right"></i></button>
                    </div>
                    <button
                        @click="$refs.addInvoiceModal.openModal()"
                        class="btn btn-primary btn-xs"
                        v-tooltip="'Factuur toevoegen'"
                    >
                        <i class="fa fa-plus"></i>
                        <span class="sr-only">Factuur toevoegen</span>
                    </button>
                </div>
            </div>
            <div class="box-body no-padding table-responsive">
                <table class="table table-striped table-hover table-condensed table-bordered centered-table-headers table-fixed">
                    <thead>
                        <tr>
                            <th rowspan="2">Klant</th>
                            <th v-for="(colspan, year) in getSpanningYears" :colspan="colspan">{{ year }}</th>
                            <th rowspan="2">Totaal <i class="fa fa-question-circle" v-tooltip="'Totaal van dit overzicht'"></i></th>
                        </tr>
                        <tr>
                            <th v-for="(n, addmonth) in 12" :class="{'bg-info':isCurrentMonth(addmonth)}">{{ moment(startperiod).add(addmonth, "month").format("MMM") }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="client in clients">
                            <td>{{ client.client }}</td>
                            <td v-for="(n, addmonth) in 12" style="max-width:100px;width:100px;" :class="{'text-right': true, 'bg-info':isCurrentMonth(addmonth)}">
                                <a
                                    v-for="invoice in client.invoices"
                                    v-if="invoiceInMonth(invoice, addmonth) && excludedinvoices.indexOf(invoice.uuid) === -1"
                                    @click="openInvoicesModal(client, addmonth)"
                                    :class="getInvoiceAnchorClass(invoice)"
                                    v-tooltip.top-end="getInvoiceAnchorTitle(invoice)"
                                    style="display:block;"
                                >{{ invoice.amount | toCurrency(false) }}</a>
                            </td>
                            <td class="text-right">{{ getClientTotal(client) | toCurrency(false) }}</td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <tr>
                            <td class="text-right">Total:</td>
                            <td v-for="(n, addmonth) in 12" style="max-width:100px;width:100px;" :class="{'text-right': true, 'bg-info':isCurrentMonth(addmonth)}">
                                {{ getTotalsForMonth(addmonth) | toCurrency(false) }}
                            </td>
                            <td class="text-right">{{ getInvoiceTotal | toCurrency(false) }}</td>
                        </tr>
                    </tfoot>
                </table>
            </div>
            <div class="overlay" v-show="loading">
                <i class="fa fa-refresh fa-spin"></i>
            </div>
        </div>
        <business-invoice-modal
            ref="invoiceModal"
            @invoice-deleted-uuid="addExcludedInvoiceUuid"
        ></business-invoice-modal>
        <business-add-invoice-modal
            ref="addInvoiceModal"
            :add-invoice-uri="addInvoiceUri"
            @invoice-added="invoiceAdded"
        ></business-add-invoice-modal>
    </div>

</template>

<script>

import {mapGetters,mapActions} from 'vuex';
import axios from 'axios';
import moment from 'moment';
import BusinessInvoiceModal from './InvoiceModal';
import BusinessAddInvoiceModal from './AddInvoiceModal';

export default {

    components: {
        BusinessInvoiceModal,
        BusinessAddInvoiceModal,
    },

    computed: {

        defaultStartperiod() {
            return moment().startOf("month").subtract(11, "month");
        },

        getInvoiceTotal(){
            let total = 0;
            this.totals.forEach(tot => total += tot.total);
            return total;
        },

        getSpanningYears() {
            let years = {};
            for (let i = 0; i < 12; i++) {
                let year = moment(this.startperiod).add(i, "month").format("YYYY");
                if (!years[year]) {
                    years[year] = 0;
                }
                years[year]++;
            }
            return years;
        },

        isResetable() {
            if (this.startperiod === null) {
                return false;
            }
            return this.startperiod.format() !== this.defaultStartperiod.format();
        },

    },

    data() {
        return {
            clients:[],
            excludedinvoices:[],
            loading:true,
            moment:moment,
            startperiod:null,
            totals:[],
        }
    },

    methods: {

        ...mapActions([
            "parseData",
        ]),

        addExcludedInvoiceUuid(invoice_uuid) {
            this.excludedinvoices.push(invoice_uuid);
        },

        invoiceAdded() {
            this.$refs.addInvoiceModal.closeModal();
            this.move(this.startperiod);
        },

        getClientTotal(client) {
            let total = 0;
            client.invoices.forEach(invoice => total += invoice.amount);
            return total;
        },

        getInvoiceAnchorClass(invoice) {
            if (invoice.overdue === true) {
                return "invoice-is-overdue";
            }
            if (invoice.paid === true) {
                return "invoice-is-paid";
            }
            if (invoice.send === true) {
                return "invoice-is-send";
            }
            return "invoice-is-pending";
        },

        getInvoiceAnchorTitle(invoice) {
            if (invoice.overdue === true) {
                return invoice.description + ". Factuur is niet binnen de betaaltermijn voldaan!";
            }
            if (invoice.paid === true) {
                return invoice.description + ". Factuur is voldaan";
            }
            if (invoice.send === true) {
                return invoice.description + ". Factuur is verzonden";
            }
            return invoice.description + ". Te versturen";
        },

        getInvoices() {
            axios.get(this.invoicesUri, {params:{startperiod:this.startperiod.format("YYYY-MM-DD")}})
            .then(resp => {
                this.clients = resp.data.data.clients;
                this.totals = resp.data.data.totals;
                this.loading = false;
            });
        },

        getTotalsForMonth(addmonth) {
            let month = moment(this.startperiod).add(addmonth, "month").month() + 1;
            if (isNaN(month)) {
                return 0;
            }
            let filtered = this.totals.filter(tot => tot.month === month);
            if (filtered.length === 0) {
                return 0;
            }
            return filtered[0].total;
        },

        invoiceInMonth(invoice, addmonth){
            let timetouse = invoice.date !== null ? invoice.date : invoice.expected_at;
            return moment(timetouse).add(12, "hour").isBetween(
                moment(this.startperiod).add(addmonth, "month").startOf("month"),
                moment(this.startperiod).add(addmonth, "month").endOf("month")
            );
        },

        isCurrentMonth(addmonth) {
            return moment().isBetween(
                moment(this.startperiod).add(addmonth, "month").startOf("month"),
                moment(this.startperiod).add(addmonth, "month").endOf("month")
            );
        },

        move(newstartperiod) {
            this.loading = true;
            this.clients = [];
            this.startperiod = newstartperiod.startOf("month");
            this.getInvoices();
        },

        moveBackwardsYear() {
            this.move(moment(this.startperiod).add(12,"hours").subtract(1, "year"));
        },

        moveBackwards() {
            this.move(moment(this.startperiod).add(12,"hours").subtract(1, "month"));
        },

        moveForward() {
            this.move(moment(this.startperiod).add(12,"hours").add(1, "month"));
        },

        moveForwardYear() {
            this.move(moment(this.startperiod).add(12,"hours").add(1, "year"));
        },

        moveReset() {
            this.move(this.defaultStartperiod);
        },

        openInvoicesModal(client, addmonth) {
            this.$refs.invoiceModal.openModal(client.paths.elementsUrl, {startperiod:moment(this.startperiod).add(addmonth, "month").format("YYYY-MM-DD")});
        },

        setStartperiod(startperiod) {
            this.startperiod = startperiod;
        },

        setYearView(year) {
            this.move(moment().year(year).startOf("year"));
        },

    },

    mounted() {
        this.setStartperiod(this.defaultStartperiod);
        this.getInvoices();
        this.parseData();
    },

    name:"BusinessInvoices",

    props: {
        invoicesUri: {
            required:true,
            type:String,
        },
        addInvoiceUri: {
            required:true,
            type:String,
        },
    },

}

</script>

<style>

table.centered-table-headers thead th,
table.centered-table-headers thead td {
    text-align:center;
}

a.invoice-is-overdue { color:red; }
a.invoice-is-paid { color:green; }
a.invoice-is-send { color:blue; }
a.invoice-is-pending { color:black; }

</style>
